import Container from "../common/Container";
import Button from "../common/Button";
import { site } from "../../data/siteData";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhone,
  FaEnvelope,
  FaLocationDot,
} from "react-icons/fa6";
import "../../styles/Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid-bg"></div>

      <Container>
        <div className="footer-grid">
          <div className="footer-brand-col">
            <div className="footer-logo-area">
              <img src="/logo.png" alt={site.brand} className="footer-logo" />
              <div>
                <div className="brand-name">{site.brand}</div>
                <div className="brand-tagline">{site.tagline}</div>
              </div>
            </div>

            <p className="footer-about-text">
              Beyond cleaning—defined by excellence. Crown Star Facility Services
              delivers premium, corporate-grade facility care across Western
              Australia, with structured systems, refined results, and
              uncompromising quality.
            </p>

            <div className="social-links">
              <a
                href={site.socials.facebook}
                className="social-icon"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href={site.socials.instagram}
                className="social-icon"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href={site.socials.linkedin}
                className="social-icon"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          <div className="footer-links-col">
            <h4 className="footer-title">Company</h4>
            <div className="footer-links">
              <a href="#about">About Us</a>
              <a href="#services">Our Services</a>
              <a href="#projects">Recent Projects</a>
            </div>
          </div>

          <div className="footer-links-col">
            <h4 className="footer-title">Help & Info</h4>
            <div className="footer-links">
              <a href="#contact">Contact Us</a>
              <a href="#pricing">Pricing Plans</a>
              <a href="#testimonials">Testimonials</a>
            </div>
          </div>

          <div className="footer-contact-col">
            <h4 className="footer-title">Get In Touch</h4>
            <div className="contact-info-list">
              <div className="contact-info-item">
                <FaLocationDot className="contact-mini-icon" />
                <span>{site.address}</span>
              </div>
              <div className="contact-info-item">
                <FaEnvelope className="contact-mini-icon" />
                <span>{site.email}</span>
              </div>
              <div className="contact-info-item">
                <FaPhone className="contact-mini-icon" />
                <span>{site.phone}</span>
              </div>
            </div>

            <div className="footer-cta">
              <Button
                variant="primary"
                className="footer-call-btn"
                onClick={() =>
                  (window.location.href = `tel:${site.phone.replace(/\s+/g, "")}`)
                }
              >
                Request a Quote
              </Button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-hr"></div>
          <div className="footer-legal">
            <p>
              © {new Date().getFullYear()} {site.brand}. All rights reserved.
            </p>

            <div className="footer-legal-links">
              <a href="#privacy">Privacy Policy</a>
              <span className="dot">•</span>
              <a href="#terms">Terms of Service</a>
              <span className="dot">•</span>
              <a
                href="https://sysconex.com"
                target="_blank"
                rel="noreferrer"
              >
                Developed by Sysconex
              </a>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
}
